import {Box, Show, Stack, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {isNotNil} from 'ramda';

interface FinancialProductCardProps {
  controls?: ReactNode;
  /** What the offer costs besides its monthly payment; opens the left column without controls. */
  details?: ReactNode;
  result: ReactNode;
  footer?: ReactNode;
}

export function FinancialProductCard(props: FinancialProductCardProps) {
  const hasLeftColumn = isNotNil(props.controls) || isNotNil(props.details);

  return (
    <VStack spacing={4}>
      <Box
        border="thin solid"
        borderColor="border.emphasisDefault"
        borderRadius="medium"
        overflow="hidden"
      >
        <Stack direction={['column', 'column', 'row']} spacing={0}>
          <Show when={hasLeftColumn}>
            <Box
              flexGrow={1}
              flexShrink={1}
              flexBasis="58%"
              padding={6}
              minWidth={0}
              backgroundColor="semantic.bg.subtle"
            >
              <VStack spacing={7} justify="space-between" height="100%">
                {props.controls}
                {props.details}
                {props.footer}
              </VStack>
            </Box>
          </Show>
          <Box flexGrow={1} flexShrink={1} flexBasis={hasLeftColumn ? '42%' : '100%'} minWidth={0}>
            {props.result}
          </Box>
        </Stack>
      </Box>
      <Show when={!hasLeftColumn}>{props.footer}</Show>
    </VStack>
  );
}
